// Earselect's producer organization, the first party of every cloud agreement.
const earselectProducerId = "HfvG4FQfXWpWv6dzqM5E";

export default earselectProducerId;
